export default __webpack_public_path__ + "fa684cf3d80d1b789a2814841955420e.svg";